/** Interpolate only between real, confirmed endpoints. Never extrapolate. */
export function interpolateExpGain(leftAt: number, leftGain: number, rightAt: number, rightGain: number, at: number): number {
  const fraction = rightAt === leftAt ? 0 : (at - leftAt) / (rightAt - leftAt)
  return leftGain + (rightGain - leftGain) * fraction
}
